// extracted by mini-css-extract-plugin
module.exports = {"selectInput":"Select_selectInput__38LHc"};